<div
  class="row form-property {{ property?.styleClass ? property.styleClass : '' }}"
>
  <div class="col-lg-12">
    <span class="p-float-label">
      <div margin-left="8" *ngIf="!property.readonly" class="truncate">
        <small
          gsHeaderTooltip="{{ hasRules ? editText : '' }}"
          anchor="host"
          class="pointer italic"
          (click)="rulesPanel.toggle($event)"
        >
          {{ summary || addText }}
        </small>
      </div>
      <label
        class="gs-float-label {{
          property?.labelClass ? property.labelClass : ''
        }}"
        [ngClass]="{ 'error-color': notValid }"
      >
        {{ property.label }}
      </label>
      <span
        *ngIf="notValid"
        class="form-error"
        pTooltip="{{ property.validationMessage }}"
        tooltipPosition="bottom"
        style="width: 25px; height: 25px"
      >
        <i class="fas fa-info-circle fa-2x form-valid-icon error-color"></i>
      </span>
    </span>
  </div>
</div>

<p-overlayPanel
  (onHide)="hide()"
  [showCloseIcon]="true"
  #rulesPanel
  [style]="{ 'min-width': '520px' }"
>
  <div style="max-height: 40vh; overflow-y: auto">
    <div [margin-left]="8" [margin-top]="8" [margin-bottom]="8">
      <span style="font-weight: 600">{{ property.label }}</span>
      <span
        *ngIf="tooltip"
        gsHeaderTooltip="{{ property.tooltip }}"
        anchor="host"
        [margin-left]="6"
      >
        <i class="fas fa-info-circle master-color"></i>
      </span>
    </div>

    <form [formGroup]="form">
      <table *ngIf="rules.length" style="width: 100%">
        <tr>
          <th [padding-left]="8" style="width: 40%">Order type</th>
          <th [padding-left]="8" style="width: 25%">Anchor</th>
          <th [padding-left]="8" style="width: 25%">Minutes</th>
          <th style="width: 10%"></th>
        </tr>
        <tr
          *ngFor="let row of rules.controls; let i = index"
          [formGroup]="row"
          style="vertical-align: top"
        >
          <td [padding-left]="8" [padding-top]="8">
            <input
              pInputText
              type="text"
              formControlName="orderType"
              style="width: 100%"
            />
            <div *ngIf="row.get('orderType').errors?.required">
              <small class="text-danger">Order type is required</small>
            </div>
            <div *ngIf="isDuplicate(i)">
              <small class="text-danger"
                >This order type already has a rule with the same anchor</small
              >
            </div>
          </td>
          <td [padding-left]="8" [padding-top]="8">
            <p-dropdown
              [appendTo]="'body'"
              [options]="anchorOptions"
              formControlName="anchor"
              placeholder="Select"
              [showClear]="false"
              [style]="{ width: '100%' }"
            >
            </p-dropdown>
            <div *ngIf="row.get('anchor').errors?.required">
              <small class="text-danger">Anchor is required</small>
            </div>
          </td>
          <td [padding-left]="8" [padding-top]="8">
            <p-inputNumber
              formControlName="minutes"
              [min]="minutesMin"
              [max]="minutesMax"
              [showButtons]="false"
              [allowEmpty]="true"
              [useGrouping]="false"
              styleClass="width-100"
            >
            </p-inputNumber>
            <div *ngIf="row.get('minutes').errors?.required">
              <small class="text-danger">Minutes is required</small>
            </div>
            <div
              *ngIf="
                row.get('minutes').errors?.min || row.get('minutes').errors?.max
              "
            >
              <small class="text-danger"
                >Minutes must be between {{ minutesMin }} and
                {{ minutesMax }}</small
              >
            </div>
          </td>
          <td [padding-top]="8" style="text-align: center">
            <i class="pi pi-trash pointer" (click)="removeRule(i)"></i>
          </td>
        </tr>
      </table>
    </form>

    <div *ngIf="!rules.length" [margin-left]="8" [margin-top]="8">
      <small class="italic">No check serve window rules configured.</small>
    </div>

    <div>
      <small
        [margin-left]="8"
        [margin-top]="8"
        style="color: var(--nav-main-background-color)"
        class="pointer"
        (click)="addRule()"
      >
        + Add rule
      </small>
    </div>

    <div class="right" [margin-bottom]="8" [margin-right]="8">
      <button
        [margin-top]="8"
        pButton
        type="button"
        label="Apply"
        class="p-button-rounded"
        [disabled]="!canApply"
        (click)="rulesPanel.hide()"
      ></button>
    </div>
  </div>
</p-overlayPanel>
